<template>
  <v-expansion-panel v-model="panel" expand v-if="quote.instructed != 0">
    <v-expansion-panel-content>
      <template v-slot:header>
        <h2><v-icon>link</v-icon>Instruction confirmation</h2>
      </template>
      <v-card>
        <v-card-text>
          <div>
            <a @click="openQuote">Quotation</a>
          </div>
          <div>
            <a @click="openCallback">Callback</a>
          </div>
          <div>
            <a @click="openInstructionConfirmationForm"
              >Instruction confirmation form</a
            >
          </div>
          <div v-if="quote.individuals">
            <h3>Individuals</h3>
            <div
              v-for="(individual, individualId) in quote.individuals"
              :key="individualId"
              :class="`rowNormal ${individualId % 2 ? '' : 'rowHighlight'}`"
            >
              <div>Title: {{ individual.title }}</div>
              <div>Forename: {{ individual.forename }}</div>
              <div>Surname: {{ individual.surname }}</div>
              <div>Dob: {{ individual.dob | formatDate }}</div>
              <div>Email: {{ individual.email }}</div>
              <div>Mobile: {{ individual.mobile }}</div>
              <div>Address: {{ individual.address }}</div>
            </div>
          </div>
          <div v-if="quote.company">
            <h3>Company</h3>
            <div class="rowNormal rowHighlight">
              <div>Name: {{ quote.company.name }}</div>
              <div>Email: {{ quote.company.email }}</div>
              <div>Address: {{ quote.company.address }}</div>
            </div>
          </div>
          <div v-if="quote.extra">
            <div v-for="(value, name) in quote.extra" :key="name">
              {{ name }}: {{ value }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "Links",
  props: ["quote", "lastUpdated"],
  data() {
    return {
      panel: [false]
    };
  },
  methods: {
    openQuote() {
      window.open(
        `${process.env.VUE_APP_NBM_SALES_URL}/quotation/${this.quote.id}/${this.quote.nbmuid}`,
        "_blank"
      );
    },
    openCallback() {
      window.open(
        `${process.env.VUE_APP_NBM_SALES_URL}/callback/${this.quote.id}/${this.quote.nbmuid}`,
        "_blank"
      );
    },
    openInstructionConfirmationForm() {
      window.open(
        `${process.env.VUE_APP_NBM_SALES_URL}/instructionConfirmation/${this.quote.id}/${this.quote.nbmuid}`,
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.rowNormal {
  padding: 10px;
  border: 1px solid #cccccc;
}
.rowHighlight {
  background: #dddddd;
}
</style>